/** Скрыть пустые/служебные подтипы витрины (general, legacy shells без SKU). */

export const VITRINE_PLACEHOLDER_SUBTYPES = new Set([
  'general',
  'standard',
  'default',
  'other',
]);

export function subtypeSlugFromGroupId(groupId: string): string {
  if (!groupId.includes('::')) return '';
  return groupId.split('::', 2)[1]?.trim().toLowerCase() ?? '';
}

export function isPlaceholderCatalogSubtype(
  subtype: string,
  slug: string,
  variantsCount: number,
): boolean {
  const sub = subtype.trim().toLowerCase();
  const slugNorm = slug.trim().toLowerCase();
  if (variantsCount <= 0) return true;
  if (VITRINE_PLACEHOLDER_SUBTYPES.has(sub) || VITRINE_PLACEHOLDER_SUBTYPES.has(slugNorm)) {
    return true;
  }
  if (/^\d+$/.test(slugNorm)) return true;
  return false;
}

export type VitrineSiblingLike = {
  group_id: string;
  name?: string;
  variants_count?: number;
};

export function filterVitrineSiblingGroups<T extends VitrineSiblingLike>(rows: T[]): T[] {
  return rows.filter((row) => {
    const vc = Number(row.variants_count ?? 0);
    if (vc <= 0) return false;
    const slug = subtypeSlugFromGroupId(row.group_id || '');
    if (VITRINE_PLACEHOLDER_SUBTYPES.has(slug)) return false;
    if (/^\d+$/.test(slug)) return false;
    return Boolean(row.group_id && (row.name || slug));
  });
}
